import axios from 'axios';

const API_URL = 'https://qwikbistro.shop';
const TOKEN = process.env.REACT_APP_QWIK_BISTRO_API_TOKEN;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const expenseApiService = {
  // Get all expenses
  getAllExpenses: async () => {
    try {
      const response = await axiosInstance.get('/expenses');
      return response.data.reverse(); // Latest first
    } catch (error) {
      console.error('Error fetching expenses:', error);
      throw error;
    }
  },

  // Get single expense
  getExpense: async (id) => {
    try {
      const response = await axiosInstance.get(`/expenses/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching expense:', error);
      throw error;
    }
  },

  // Update expense
  // updateExpense: async (id, expenseData) => {
  //   try {
  //     const response = await axiosInstance.put(`/expenses/${id}`, expenseData);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error updating expense:', error);
  //     throw error;
  //   }
  // },

  updateExpense: async (id, expenseData) => {
    try {
      const response = await axiosInstance.patch(`expenses/${id}`, expenseData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating expense:', error);
      throw error;
    }
  },

  // Delete expense
  deleteExpense: async (id) => {
    try {
      await axiosInstance.delete(`/expenses/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting expense:', error);
      throw error;
    }
  },

  // Create new expense
  // createExpense: async (expenseData) => {
  //   try {
  //     const response = await axiosInstance.post('/expenses/new', expenseData);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error creating expense:', error);
  //     throw error;
  //   }
  // },

  // Create new expense
  createExpense: async (expenseData) => {
    try {
      const response = await axiosInstance.post('expenses/new', expenseData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating expense:', error);
      throw error;
    }
  },

};